import { render, staticRenderFns } from "./ExibirRoles.vue?vue&type=template&id=6112efcc&scoped=true&"
import script from "./ExibirRoles.vue?vue&type=script&lang=js&"
export * from "./ExibirRoles.vue?vue&type=script&lang=js&"
import style0 from "./ExibirRoles.vue?vue&type=style&index=0&id=6112efcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6112efcc",
  null
  
)

export default component.exports